import { render, staticRenderFns } from "./welfareDetail.vue?vue&type=template&id=782bff26"
import script from "./welfareDetail.vue?vue&type=script&lang=js"
export * from "./welfareDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports